export const gameBoardState = {
    state:() => ({
      words: [
        { text: "code", color: "white"},
        { text: "names", color: "white"},
        { text: "plus", color: "white"},
        { text: "peer", color: "white"},
        { text: "to", color: "white"},
        { text: "peer", color: "white"},
        { text: "code", color: "white"},
        { text: "names", color: "white"},
        { text: "plus", color: "white"},
        { text: "peer", color: "white"},
        { text: "to", color: "white"},
        { text: "peer", color: "white"},
        { text: "code", color: "white"},
        { text: "names", color: "white"},
        { text: "plus", color: "white"},
        { text: "peer", color: "white"},
        { text: "to", color: "white"},
        { text: "peer", color: "white"},
        { text: "code", color: "white"},
        { text: "names", color: "white"},
        { text: "plus", color: "white"},
        { text: "peer", color: "white"},
        { text: "to", color: "white"},
        { text: "peer", color: "white"}
      ]
    }),
    getters: {
      gameWords: state => {
        return state.words;
      },
      hasViewPermission: state => {
        return state.isSpyMaster;
      }
    },
    mutations: {},
    actions: {}
};
